/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';
  /**
   * Базовый Popup, подойдет для создания простых Popup'ов
   */
  app.PopupView = app.View.extend({
    run: function (data) {
      var options = data || {};
      var opener = this.$el;
      var css = options.css ? options.css(opener) : {};
      var popupId = this.$el.data('id');
      var popup = $('[data-popup-id="' + popupId + '"]');
      
      this.initPopup(popup, opener, css);
    },
    
    initPopup: function (popup, opener, css) {
      this.popup = new als.Popup(popup, opener);
      this.popup.addEventListener(
        als.Popup.EventType.BEFORE_OPEN,
        function () {
          popup.css(css);
        }
      );
    }
  });
})(jQuery);

}.call(window));